import { IPrivateLeagueAdmin } from "core-integration/src/store/leagues/types";
import React, { useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import Button from "../../Button";
import { FieldWrap } from "../../FieldRenderers";
import SubHeading from "../../SubHeading";
import EntrySelector from "./EntrySelector";

interface IOwnProps {
  updateAdmin: (entryId: number) => void;
  league: IPrivateLeagueAdmin;
}

type Props = IOwnProps & WithTranslation;

const ChangeAdmin: React.FC<Props> = ({ league, t, updateAdmin }) => {
  const [entry, setEntry] = useState<number>(0);

  const handleEntryChange = (entryId: number) => {
    setEntry(entryId);
  };

  const handleSubmit = (e: React.SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault();
    updateAdmin(entry);
  };

  const disabled = !entry;
  return (
    <>
      <SubHeading>
        {t("changeAdmin.title", "Change league administrator")}
      </SubHeading>
      <form onSubmit={handleSubmit}>
        <FieldWrap>
          <EntrySelector
            handleChange={handleEntryChange}
            leagueId={league.id}
            excluded={[league.admin_entry]}
          />
        </FieldWrap>
        <FieldWrap>
          <Button type="submit" disabled={disabled}>
            {t("changeAdmin.cta", "Change administrator")}
          </Button>
        </FieldWrap>
      </form>
    </>
  );
};

export default withTranslation()(ChangeAdmin);
